import { makeStyles, tokens, Button, typographyStyles } from "@fluentui/react-components";
import { ChevronLeftFilled as BackIcon } from "@fluentui/react-icons";
import React from "react";
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles({
  flex: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    gap: '4px'
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px'
  },
  heading: {
    ...typographyStyles.title3,
    marginBottom: 0,
    color: tokens.colorNeutralForeground1
  },
  description: {
    ...typographyStyles.caption1,
    color: tokens.colorNeutralForeground3
  },
  a: {
    color: tokens.colorBrandForeground1,
    textDecoration: 'underline',
    cursor: 'pointer',
  }
});

interface IAppValidationHeader {
  onBackNavigation?: () => void;
  showBackNavigation?: boolean;
  title: React.ReactNode
  description: React.ReactNode
  link?: React.ReactNode
  href?: string
}

export const AppDetailsHeader: React.FC<IAppValidationHeader> = ({
  onBackNavigation,
  showBackNavigation,
  title,
  description,
  link,
  href
}) => {
  const classes = useStyles();
  return (
    <div className={classes.flexColumn}>
      {showBackNavigation &&
        <Button
          appearance='transparent'
          icon={<BackIcon />}
          onClick={onBackNavigation}
          aria-label="Back"
        />
      }
      <div className={classes.flex}>
        <div className={classes.heading}>
          {title}
        </div>
        <div className={classes.description}>
          <span>
            {description}
          </span>
          &nbsp;
          {
            href && <a className={classes.a} href={href} target="_blank" rel="noopener noreferrer">
              {link}
            </a>
          }
        </div>
      </div>
    </div>
  )

};
